import { render, staticRenderFns } from "./f1.vue?vue&type=template&id=3a91243c&scoped=true&"
import script from "./f1.vue?vue&type=script&lang=js&"
export * from "./f1.vue?vue&type=script&lang=js&"
import style0 from "./f1.vue?vue&type=style&index=0&id=3a91243c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a91243c",
  null
  
)

component.options.__file = "f1.vue"
export default component.exports